export const FETCH_AUTH = 'auth/FETCH_AUTH';
export const FETCH_AUTH_START = 'auth/FETCH_AUTH_START';
export const FETCH_AUTH_FINISHED = 'auth/FETCH_AUTH_FINISHED';

export const SET_USER = 'auth/SET_USER';

export const IS_AUTHENTICATED = 'auth/IS_AUTHENTICATED';

export const LOG_OUT = 'auth/LOG_OUT';
